<dynamic-form
  [apiName]="apiName"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [group]="formGroup"
  [columns]="columns"
  [noSubmit]="deactivateSave"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="fcContent col-lg-12">
    <ssg-input
      size="small"
      isFloat="1"
      [group]="formGroup"
      name="start"
      textType="number"
      [max]="999"
      [isNumberOnly]="true"
      [label]="'ClientApp.FrontOffice.Salon.StartNumber' | translate"></ssg-input>
    <ssg-input
      size="small"
      name="end"
      textType="number"
      [max]="999"
      [isNumberOnly]="true"
      [label]="'ClientApp.FrontOffice.Salon.EndNumber' | translate"
      [group]="formGroup"></ssg-input>
    <ssg-input
      size="small"
      [group]="formGroup"
      name="tableName"
      textType="text"
      [label]="'ClientApp.FrontOffice.Salon.TableTitle' | translate"></ssg-input>
    <ssg-button
      (click)="ngCreateTables()"
      class="login-btn"
      [label]="'ClientApp.FrontOffice.Salon.Create' | translate"
      buttontype="button"
      appearance="flat"></ssg-button>
  </div>
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
  <ng-container class="content">
    <ssg-tabset class="tabcontainer">
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Salon.Tables' | translate">
        <div class="tabletab">
          <editable-grid *ngIf="Tables?.length > 0 && model.Tables" [columns]="Tables" [dataList]="model.Tables" [hideToolber]="true">
          </editable-grid>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
